<template>
  <GhostContent :slug="route.params.slug as string" tag="brand" />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'content'
})

const route = useRoute()
</script>
